import { useEffect } from 'react';

const HubspotTracking = () => {
    useEffect(() => {
        const head = document.querySelector('head');
        const script = document.createElement('script');
        script.setAttribute('src', '//js.hs-scripts.com/3796264.js');
        script.setAttribute('id', 'hs-script-loader');
        script.setAttribute('type', 'text/javascript');
        script.async = true;
        head.appendChild(script);

        return () => {
            const script = document.getElementById('hs-script-loader');
            script.parentNode.removeChild(script);
        };
    });

    return <></>;
};

export default HubspotTracking;
